module.exports = __webpack_public_path__ + "static/profile-pic-6a5eb90a44df11ba749c0c5d2cd888c9.jpg";